export default "__VITE_ASSET__62573213__"